import { useMutation } from '@tanstack/react-query';

import { api } from '@app/utils/api';
import { errorHandler } from '@app/utils/errorHandler';
import { IUser } from '@entities/user/IUser';
import { AUTH_BASE_URL } from '@app/contstants/endpoints';

export const fetchUser = async (): Promise<IUser> => {
  const response = await api.get<IUser>(`${AUTH_BASE_URL}/auth/api/v1/me`);

  return response.data ?? [];
};

export const useGuardUser = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetchUser,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
